import { Process } from "./types";

export function IconClass(process) {
  switch (process) {
    case Process.Order:
    case Process.BulkOrder:  
      return 'icon-bell icons';
    case Process.BasketOrder:
      return 'fa fa-shopping-basket';

    case Process.CorpEvent:
      return 'icon-bulb icons';
  }
}